import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value, currency = 'USD') {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(value);
}

export function formatDate(date, format = 'short') {
  if (!date) return '';
  const d = new Date(date);
  if (format === 'short') {
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }
  return d.toLocaleDateString('en-US');
}

export function normalizeStatus(status) {
  if (!status) return 'draft';
  return status.toLowerCase().replace(/\s+/g, '_');
}

export function getStatusLabel(status) {
  if (!status) return 'Draft';
  return status.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
}